import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CampaignStatus } from 'src/app/models/campaign';
import { CampaignService } from 'src/app/services/campaign.service';

@Component({
    selector: 'app-campaign-edit-user-modal',
    templateUrl: './campaign-edit-user-modal.component.html',
    styleUrls: ['./campaign-edit-user-modal.component.scss']
})
export class CampaignEditUserModalComponent {
    public campaignId: string;
    public status: CampaignStatus;
    public allowEditingStatuses: CampaignStatus[] = [
        CampaignStatus.PENDING_APPROVAL,
        CampaignStatus.PAUSED,
        CampaignStatus.PENDING_REAPPROVAL,
        CampaignStatus.PARTIALLY_REJECTED
    ];
    constructor(
        public dialogRef: MatDialogRef<CampaignEditUserModalComponent>,
        private campaignService: CampaignService,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.campaignId = data.id;
        this.status = data.status;
    }

    ngOnInit(): void { }

    getTitle() {
        switch (this.status) {
            case CampaignStatus.LIVE:
                return 'Your campaign is live, if your campaign is already running, changes you do here will not affect your live campaign unless you submit updates';
            case CampaignStatus.PAUSED_PENDING_SUP_APPROVALS:
                return 'Rejected and pending channels can be fully edited. For approved channels, you will be able to edit your visuals only. Please make sure to republish to recalculate your campaign fees. In case any supplier has already paid the municipality fees on your behalf, it will be charged separately. Are you sure you want to edit?';
            case CampaignStatus.PENDING_APPROVAL:
            case CampaignStatus.PARTIALLY_REJECTED:
            case CampaignStatus.PAUSED:
            case CampaignStatus.PENDING_REAPPROVAL:
                return 'Please make sure to republish your campaign in order to notify your suppliers of any changes and to recalculate your campaign fees. In case any supplier has already paid the municipality fees on your behalf, it will be charged separately. Are you sure you want to edit?';
        }
    }

    updateCampaignStatus(): void {
        if (this.allowEditingStatuses.includes(this.status)) {
            this.campaignService
                .updateCampaignStatus(this.campaignId, CampaignStatus.BEING_EDITED)
                .subscribe(response => {
                    if (
                        response['relaunchStatus'] == CampaignStatus.LIVE ||
                        response['relaunchStatus'] == CampaignStatus.PARTIALLY_LIVE
                    ) {
                        this.dialogRef.close({ status: true, isPausedLive: true });
                    } else {
                        this.dialogRef.close({ status: true });
                    }
                });
        }
    }
}
